import React from 'react';
import { ConfirmModal } from '../../commons/components/ConfirmModal';
import BusinessPlanFinancialTemplateInstruction from '../../assets/images/business-plan-financial-template-instruction.png';
import { businessPlanConfig } from '../../commons/config';

export const FinancialTemplateInstructionsModal = (props: {
  presignedLink: string;
  onClose: () => void;
}) => {
  const { onClose, presignedLink } = props;

  return (
    <ConfirmModal
      title="Financial Analysis Template Instructions"
      footer={{
        type: 'show',
        applyButton: {
          label: 'Got it',
          onClick: onClose,
        },
      }}
      onClose={onClose}
    >
      <div className="financial-template-instructions">
        <div className="financial-template-instructions__content">
          <p>
            The final step to finishing your business plan is the financial analysis document. The
            document should automatically download to your browser. If not,{' '}
            <a href={presignedLink} target="_blank" rel="noopener noreferrer">
              click this link
            </a>
            .
          </p>

          <p>
            The document is in Excel format. Once you open the file, you will see four tabs at the
            bottom:
          </p>

          <div className="financial-template-instructions__image-container">
            <img
              src={BusinessPlanFinancialTemplateInstruction}
              alt="Business Plan Financial Template Tabs"
              className="financial-template-instructions__image"
            />
          </div>

          <p>
            You need to fill in the <strong>Profit Loss Input</strong> and{' '}
            <strong>Balance Sheet Input</strong>. There are some instructions at the top of each
            page to help you along. The page titled <strong>PRINT</strong> will auto-populate based
            on the information you provided in the first two tabs. This is the only page you will
            print. Once ready, you will choose print, then choose print to PDF. This will print your
            analysis in a format that can then be attached to the back of your business plan.
          </p>

          <p className="financial-template-instructions__warning">
            <strong>
              Please ensure that you enter your data only in the designated cells. The document
              contains numerous formulas, and altering any of these formulas may affect the results.
            </strong>
          </p>

          <p>
            You can watch a tutorial for our financial analysis template{' '}
            <a href="https://youtu.be/zj26MHJO8Sk" target="_blank" rel="noopener noreferrer">
              here
            </a>
            .
          </p>

          <p>
            If you are having trouble filling out the financial analysis template, you can schedule
            a paid one-on-one video consultation through Zoom. These consultations are 30 minutes
            long and cost $30, invoiced on Net 30 terms. You can cancel or reschedule the
            appointment without penalty, but if you do not show up, you will still be charged the
            fee. To schedule your consultation, you can{' '}
            <a href={businessPlanConfig.consultationUrl} target="_blank" rel="noopener noreferrer">
              click here
            </a>
            .
          </p>

          <p>
            Please feel free to reach out to{' '}
            <a href="mailto:support@growegy.com">support@growegy.com</a> with any questions, or
            reach out to your account manager.
          </p>
        </div>
      </div>
    </ConfirmModal>
  );
};
